<template>
    <div class="property-web-register">
        <header>
            <div class="nav">
                <div class="left" @click="goHome">
                    <div class="nav-title">
                        <img :src="require('@/assets/home/logo.png')" />
                        <span>国家烟草质量监督检验中心</span>
                        <span> | </span>
                        <span class="nav-subtitle">用户注册</span>
                    </div>
                </div>
                <div class="right">
                    <span>已有账号，</span>
                    <a @click="toLogin">立即登录</a>
                </div>
            </div>
        </header>
        <body class="page-body">
            <div class="register-finish" v-if="registerDone">
                <img :src="require('@/assets/login/register-done.svg')" alt="" />
                <div class="success">提交成功</div>
                <div class="desc">客服将尽快对您的申请进行审核</div>
                <div class="success-btn" @click="goHome">进入首页</div>
            </div>
            <div class="register-content" v-else>
                <content-title title="用户注册" />

                <div class="form-content">
                    <a-steps :current="signInState" labelPlacement="vertical">
                        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                    </a-steps>

                    <transition-group name="moveR">
                        <register-form ref="registerForm" v-show="signInState === 0" key="1" />
                        <company-info ref="companyInfoForm" v-show="signInState === 1" key="2" />
                        <bank-info ref="bankInfoForm" v-show="signInState === 2" key="3" />
                    </transition-group>

                    <div class="process-btns">
                        <div class="btn prev" @click="prevHandle" v-show="signInState !== 0">上一步</div>
                        <div :class="['btn', 'next', { done: signInState === 2 }]" @click="nextHandle">
                            {{ signInState === 2 ? '注册提交' : '下一步' }}
                        </div>
                    </div>
                </div>
            </div>
        </body>

        <footer>
            <p>
                <span>地址:郑州市国家高新技术产业开发区翠竹街6号</span>
                <span>电话:0371-67672608</span>
                <span>邮箱:ctqtchuiyi@126.com</span>
                <span>邮编:450001</span>
            </p>
            <p>版权所有:国家烟草质量监督检验中心，未经许可，本网站包括图像、图标、文字在内的所有数据不得转载</p>
        </footer>
    </div>
</template>

<script>
import contentTitle from '../../components/content-title.vue';
import registerForm from './components/register/register-form.vue';
import companyInfo from './components/register/company-info.vue';
import bankInfo from './components/register/bank-info.vue';
import { userRegistration } from '@/common/api';

export default {
    components: {
        contentTitle,
        registerForm,
        companyInfo,
        bankInfo
    },
    data() {
        return {
            steps: [{ title: '账号注册' }, { title: '企业基本信息' }, { title: '企业税务信息' }],
            signInState: 0,
            registerDone: false,
            params: {}
        };
    },
    methods: {
        prevHandle() {
            if (this.signInState === 0) return;
            this.signInState -= 1;
        },

        toHome() {
            this.$router.push({ name: 'home' });
        },

        async nextHandle() {
            if (this.signInState === 2) {
                await this.userRegister();
                this.registerDone = true;
                return;
            }
            // if (this.signInState === 0) {
            //     const pass = await this.$refs.registerForm.validate();
            //     if (!pass) return;
            // } else if (this.signInState === 1) {
            //     const pass = await this.$refs.companyInfoForm.validate();
            //     if (!pass) return;
            // }

            this.signInState += 1;
        },

        async userRegister() {
            const form1 = this.$refs.registerForm.form;
            const form2 = this.$refs.companyInfoForm.form;
            const form3 = this.$refs.bankInfoForm.form;
            this.params = {
                ...form1,
                ...form2,
                ...form3
            };
            if (this.params.checkPass) {
                delete this.params.checkPass;
            }
            await userRegistration(this.params).then(res => {
                if (res.status === 200) {
                    this.$message.success('注册成功！');
                }
            });
        },

        toLogin() {
            this.$router.push({ name: 'login' });
        },

        goHome() {
            this.$router.push({ name: 'home' });
        }
    }
};
</script>

<style lang="scss" scoped>
.property-web-register {
    display: flex;
    flex-direction: column;
    height: 100%;
    header {
        background: #e6f2ff;
    }
    .nav {
        display: flex;
        margin: 0 auto;
        width: 1200px;
        height: 128px;
        justify-content: space-between;
        align-items: center;

        .left {
            cursor: pointer;

            > .nav-title {
                display: flex;
                align-items: center;
            }

            span {
                margin-left: 16px;
                font-size: 32px;
                color: #005299;
                font-weight: 700;

                &:not(:first-child) {
                    margin-left: 12px;
                }
            }

            .nav-subtitle {
                font-weight: normal;
            }
        }
        .right {
            a {
                color: #0a65b9;
            }
        }
    }

    .page-body {
        background-color: #f8faff;
        padding: 16px 0 56px;

        .register-finish,
        .register-content {
            width: 1200px;
            margin: 0 auto;
            height: 100%;
            background-color: #fff;
        }

        .register-finish {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            font-family: PingFangSC-Semibold;
            padding: 206px 0 306px;

            .success {
                font-size: 24px;
                color: #333333;
                text-align: center;
                line-height: 34px;
                font-weight: 600;
                margin: 24px 0 16px;
            }

            .desc {
                font-size: 16px;
                color: #666666;
            }
            .success-btn {
                background: #0a65b9;
                margin-top: 32px;
                border-radius: 2px;
                color: #fff;
                font-size: 16px;
                text-align: center;
                width: 104px;
                height: 40px;
                line-height: 40px;
                cursor: pointer;
            }
        }

        .register-content {
            .content-title {
                margin: 13px 16px 0;
            }

            .form-content {
                padding: 40px 327px 30px;

                :deep(.ant-steps) {
                    margin-bottom: 32px;
                    .ant-steps-item-icon {
                        width: 54px;
                        height: 54px;
                        border: none;
                        font-size: 18px;
                        color: #ffffff;
                        letter-spacing: 0;
                        font-weight: 600;

                        .ant-steps-icon {
                            display: flex;
                            border-radius: 50%;
                            width: 100%;
                            height: 100%;
                            transform: scale(0.81);
                            align-items: center;
                            justify-content: center;
                        }
                    }

                    .ant-steps-item-process {
                        .ant-steps-item-icon {
                            background: #d8eaff;

                            .ant-steps-icon {
                                background: #1d87e3;
                                border: 1px solid #2a86d5;
                                box-shadow: 0px 3px 6px 0px rgba(11, 44, 109, 0.16);
                            }
                        }
                    }

                    .ant-steps-item-wait {
                        .ant-steps-item-icon {
                            background: #ececec;

                            .ant-steps-icon {
                                background: #eaeaea;
                                border: 1px solid rgba(213, 213, 213, 1);
                                box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
                                color: #666666;
                            }
                        }
                    }

                    .ant-steps-item-finish {
                        .ant-steps-item-icon {
                            background: rgba(25, 195, 137, 0.12);

                            .ant-steps-icon {
                                background: #19c389;
                                border: 1px solid rgba(41, 188, 138, 1);
                                box-shadow: 0px 3px 6px 0px rgba(20, 151, 106, 0.29);
                                color: #fff;
                                font-size: 24px;
                            }
                        }

                        > .ant-steps-item-container {
                            > .ant-steps-item-tail {
                                &::after {
                                    background: #19c389;
                                }
                            }
                        }
                    }

                    .ant-steps-item {
                        > .ant-steps-item-container {
                            > .ant-steps-item-content {
                                margin-top: 0;
                                margin-left: 10px;
                                > .ant-steps-item-title {
                                    font-size: 16px;
                                    color: #333333;
                                    letter-spacing: 0;
                                    font-weight: 600;
                                }
                            }

                            > .ant-steps-item-tail {
                                top: 22px;
                                margin-left: 67px;

                                &::after {
                                    height: 3px;
                                }
                            }
                        }
                    }
                }
            }

            .process-btns {
                display: flex;
                justify-content: center;
                align-items: center;

                > .btn {
                    width: 104px;
                    height: 40px;
                    background: #ffffff;
                    border: 1px solid #0a65b9;
                    border-radius: 2px;
                    font-family: PingFangSC-Regular;
                    font-size: 16px;
                    color: #0a65b9;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                }

                .prev {
                    margin-right: 16px;
                }

                .btn.done {
                    background: #0a65b9;
                    color: #fff;
                }
            }
        }
    }

    footer {
        width: 100%;
        height: 128px;
        background: #005299;
        color: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        p {
            span {
                margin-right: 48px;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}

.moveR-enter-active,
.moveR-leave-active {
    transition: all 0.3s linear;
    transform: translateX(0);
}
.moveR-enter,
.moveR-leave {
    opacity: 0;
    transform: translateX(100%);
}
.moveR-leave-to {
    transform: translateX(100%);
}
</style>
